export const ModelPortfolioType = {
    Conservative: 1,
    Balanced: 3,
    Growth: 4,
    HighGrowth: 5,
    International: 6,
    IIGrowth: 7,
    IIIncome: 8,
    Property: 9,
    InterestIncome: 10,
    HybridIncome: 13,
    SmallCompaniesFund: 14,
    INIF: 166,
    IIEthical: 168,
    INES: 169,
    AustralianEquities: 170,
    Cash: 171,
    IIGF: 174,
    EthicalGrowth: 176,
    EthicalHighGrowth: 189,
    EurekaFund: 177,
    IISV: 178,
    SelectValue: 179,
    RaskTerra: 180,
    RaskMartian: 181,
    RaskJupiter: 182,
    MMInternationalEquities: 183,
    MMCoreETF: 184,
    MMActiveIncome: 185,
    MMEmergingCompanies: 186,
    MMActiveGrowth: 187,
    MMCashSecurities: 190,
    RaskLuna: 188,
    RaskSaturn: 191,
    RaskMercury: 192,
    RaskSolar: 193,
};

export const ModelPortfolioBaseType = {
    SMA: 1,
    LIC: 2,
    EQMF: 3,
    Fund: 4
}

export const RequestDownloadDocument = {
    PDS: 1,
    InvestorPack: 2,
    FeesSpecialReport: 3,
    INES_DRP_Rules: 4,
    INIF_DRP_Rules: 5,
    IIGF_DRP_Rules: 6,
    ETF_Report: 7,
    Retirement_Report: 8,
    Wealth_Report: 9
}

export const DEFAULT_MODELPORTFOLIOS_QUERY_OPTIONS = {
    DisplayIS: true,
    HasBenchmark: true,
    IsInvestable: true,
    IsLoadAssetAllocation: true,
    IsLoadBenchmarks: true,
    IsLoadDocumentUrls: true,
    IsLoadHoldingsAndPrices: true,
    IsLoadPerformanceStats: true,
    Types: ModelPortfolioBaseType.SMA
}